import {
    AiOutlineAppstore,
    IoHomeOutline,
    IoNotificationsOutline,
    AiOutlineTeam,
    AiOutlineSchedule,
    AiTwotoneFile,
    AiOutlineHome,
    IoMedkitOutline,
    AiOutlineBank,
    AiOutlineWarning,
    AiOutlineDesktop,
    MdInsertChartOutlined,
    TbStethoscope,
    AiOutlineApartment,
} from 'react-icons/all';
import React from 'react';
import {
    AccountTeamAdmin,
    AdminRoles,
    ClinicalConsultRoles,
} from '../../../global/constants';
import { IsArrayWithLength, UserHasRoles } from '../../../utilities/extensions';
import { BankTwoTone } from '@ant-design/icons';
import { AppstoreOutlined, HomeOutlined } from '@ant-design/icons';

const CoreSideMenuItems = [
    {
        key: 'dashboard',
        icon: <AiOutlineHome />,
        label: 'Dashboard',
        path: 'dashboard',
    },
    {
        key: 'account-team',
        icon: <AiOutlineAppstore />,
        label: 'Account Team',
        roles: AccountTeamAdmin,
        to: '/account-team',
        children: [
            {
                key: 'notifications',
                icon: <IoNotificationsOutline />,
                label: 'Notifications',
                roles: AccountTeamAdmin,
            },
            {
                key: 'data-integration-failures',
                icon: <AiOutlineWarning />,
                label: 'Data Integration Failures',
                roles: AccountTeamAdmin,
            },
            {
                key: 'device-session-management',
                icon: <AiOutlineDesktop />,
                label: 'Device / Session Management',
                roles: AccountTeamAdmin,
            },
        ],
    },
    {
        key: 'reporting',
        icon: <MdInsertChartOutlined />,
        label: 'Reporting',
        roles: AccountTeamAdmin,
        to: '/reporting',
        children: [
            {
                key: 'clinical-report',
                icon: <TbStethoscope />,
                label: 'Clinical Reporting',
                roles: AccountTeamAdmin,
            },
            {
                key: 'system-operations',
                icon: <AiOutlineWarning />,
                label: 'System Operations',
                roles: AccountTeamAdmin,
            },
        ],
    },
    {
        key: 'clinical-team',
        icon: <IoMedkitOutline />,
        label: 'Clinical Team',
        roles: ClinicalConsultRoles,
        to: '/clinical-team',
        children: [
            {
                key: 'clinical-consults',
                icon: <AiOutlineSchedule />,
                label: 'Clinical Consults',
                roles: ClinicalConsultRoles,
            },
        ],
    },
    {
        key: 'organizations',
        icon: <AiOutlineApartment />,
        label: 'Organizations',
        roles: AdminRoles,
        to: '/organizations',
    },
];

const SideMenuItems = [];
export const MenuRoles = {};

export const ReLoadMenuItems = () => {
    ClearMenuItems();
    CoreSideMenuItems.forEach((m) => {
        let menu = undefined;
        if (m.roles === undefined || UserHasRoles(m.roles))
            menu = { ...m, children: [] };
        if (IsArrayWithLength(m.roles)) MenuRoles[`/${m.key}`] = [...m.roles];

        if (IsArrayWithLength(m.children)) {
            const children = m.children.filter((cm) =>
                IsArrayWithLength(cm.roles),
            );
            if (IsArrayWithLength(children)) {
                children.forEach((cm) => {
                    MenuRoles[`/${m.key}/${cm.key}`] = [...cm.roles];
                });
            }
            m.children
                .filter(
                    (cm) => cm.roles === undefined || UserHasRoles(cm.roles),
                )
                .forEach((cm) => {
                    menu.children.push({ ...cm });
                });
        }
        if (menu !== undefined) {
            if (!IsArrayWithLength(menu.children)) delete menu.children;
            SideMenuItems.push(menu);
        }
    });
};

export const ClearMenuItems = () => {
    SideMenuItems.length = 0;
    Object.keys(MenuRoles).forEach((key) => {
        delete MenuRoles[key];
    });
};

if (!IsArrayWithLength(SideMenuItems) || !IsArrayWithLength(MenuRoles))
    ReLoadMenuItems();

export default SideMenuItems;
